const dateTime = (horario) => `${horario.date}T${horario.horaInicial}`;

const getWeekDay = (dia) => {
  // para evitar que o timezone troque o dia
  console.log(dia.dia);
  //var diaSplit = dia.dia.split(' ');
  const date = new Date(`${dia.dia}`);
  const weekdays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  const dayOfWeek = date ? date.getDay() : NaN;
  return isNaN(dayOfWeek) ? null : weekdays[dayOfWeek];
};

export class Agendamentos {
  campus: {
    codigo: string,
    descricao: string,
  }[];
  dia: {
    anoVestibular: number,
    codigo: number,
    codigoHora: string,
    codigoVestibular: number,
    dia: string,
    hora: {
      codigo: string,
      horaInicial: string,
      horaFinal: string,
    },
    indrea: string,
    tipo: string,
    vestibular: any,
  }[];

  constructor(args) {
    Object.assign(this, args);
  }
}

export class AgendamentosDTO {
  locais: {
    codigo: string,
    descricao: string,
  }[];
  datas: {
    codigoHora: string,
    date: string,
    horaInicial: string,
    horaFinal: string,
    descricaoFull: string,
    descricaoDisplay: string,
    descricao: string,
  }[];

  static convertAgendamentosToAgendamentosDTO(agendamentos: Agendamentos): AgendamentosDTO {
    const locais = agendamentos.campus.sort((a, b) =>
      a.descricao > b.descricao ? 1 : -1,
    );

    const temp = [];
    for (const dia of agendamentos.dia) {
      console.log(agendamentos);
      const weekday = getWeekDay(dia);
      const dateParts = dia.dia.split('-');
      const data = `${dateParts[2]}/${dateParts[1]}`;
      const horaIniParts = dia.hora.horaInicial.split(':');
      const horaInicio = `${horaIniParts[0]}:${horaIniParts[1]}`;
      const horaTerParts = dia.hora.horaFinal.split(':');
      const horaTermino = `${horaTerParts[0]}:${horaTerParts[1]}`;

      temp.push({
        codigoHora: dia.codigoHora,
        date: dia.dia,
        horaInicial: dia.hora.horaInicial,
        horaFinal: dia.hora.horaFinal,
        descricaoFull: `${weekday}, ${data} das ${horaInicio} às ${horaTermino}`,
        descricaoDisplay: `${weekday}, ${data} às ${horaInicio}`,
        descricao: `${data} às ${horaInicio}`,
      });
    }

    const datas = temp.sort((a, b) =>
      dateTime(a) > dateTime(b) ? 1 : -1,
    );

    return new AgendamentosDTO({ locais: locais, datas: datas });
  }

  constructor(args) {
    Object.assign(this, args);
  }
}

export class AgendamentosCampusDisponiveis {
  campus: {
    codigo: string,
    descricao: string,
  }[];

  constructor(args) {
    Object.assign(this, args);
  }
}

export class AgendamentosDatasPorCampus {
  datas: {
    codigoHora: string,
    date: string,
    horaInicial: string,
    horaFinal: string,
    descricaoFull: string,
    descricaoDisplay: string,
    descricao: string,
  }[];

  static convertAgendamentosToAgendamentosDTO(datas): AgendamentosDTO {
    const datasTemp = datas.map(dia => {
      //console.log(dia);
      const weekday = getWeekDay(dia);
      const dateParts = dia.dia.split('-');
      const datePartsDay = dateParts[2].split(' ')[0];
      //console.log(dateParts);
      const data = `${datePartsDay}/${dateParts[1]}`;
      const horaIniParts = dia.hora.horaInicial.split(':');
      const horaInicio = `${horaIniParts[0]}:${horaIniParts[1]}`;
      const horaTerParts = dia.hora.horaFinal.split(':');
      const horaTermino = `${horaTerParts[0]}:${horaTerParts[1]}`;

      dia.codigoHora = dia.codigoHora;
      dia.date = dia.dia;
      dia.horaInicial = dia.hora.horaInicial;
      dia.horaFinal = dia.hora.horaFinal;
      dia.descricaoFull = `${weekday}, ${data} das ${horaInicio} às ${horaTermino}`;
      dia.descricaoDisplay = `${weekday}, ${data} às ${horaInicio}`;
      dia.descricao = `${data} às ${horaInicio}`;
      return dia;
    }).sort((a, b) => dateTime(a) > dateTime(b) ? 1 : -1);

    return new AgendamentosDTO({ datas: datasTemp });
  }
}
